const set_client_listing = (state, clients) => {
  state.clients = clients;
};

const set_client = (state, client) => {
  state.client = client;
};

const set_consultant_listing = (state, consultants) => {
  state.consultants = consultants;
};

const set_site_listing = (state, sites) => {
  state.sites = sites;
};

const set_site = (state, site) => {
  state.site = site;
};

const set_building_listing = (state, buildings) => {
  state.buildings = buildings;
};

const set_building = (state, building) => {
  state.building = building;
};

const set_plant_listing = (state, plants) => {
  state.plants = plants;
};

const set_plant = (state, plant) => {
  state.plant = plant;
};

const set_plantTypes = (state, plantTypes) => {
  state.plantTypes = plantTypes;
};

const set_consultant = (state, consultant) => {
  state.consultant = consultant;
};

const set_client_contacts_listing = (state, contacts) => {
  state.clientContacts = contacts;
};

const set_client_contact = (state, clientContact) => {
  state.clientContact = clientContact;
};

const delete_client_contact_by_id = (state, id) => {
  const i = state.clientContacts.map(item => item.id).indexOf(id);
  if (i !== -1) state.clientContacts.splice(i, 1);
};

const set_building_to_active = state => {
  state.building.stateId = 1;
};

const set_site_to_active = state => {
  state.site.stateId = 1;
};

const set_client_to_active = state => {
  state.client.stateId = 1;
};

export default {
  delete_client_contact_by_id,
  set_building_to_active,
  set_client_to_active,
  set_site_to_active,
  set_client,
  set_client_contacts_listing,
  set_client_contact,
  set_client_listing,
  set_consultant,
  set_consultant_listing,
  set_site_listing,
  set_site,
  set_building_listing,
  set_building,
  set_plant_listing,
  set_plant,
  set_plantTypes
};
